"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Video Provider Configuration Information Service
 * Video provider configuration REST API for Frumos.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionManagerType = void 0;
/**
 * Type of the session management service, which defines the protocol to use for the session.
 * @export
 * @enum {string}
 */
exports.SessionManagerType = {
    AdrenalinTraxis5j: 'adrenalinTraxis5j',
    Cubiware: 'cubiware',
    Tivo: 'tivo',
    TivoPlus: 'tivoPlus',
    TivoCubiware: 'tivoCubiware'
};
